import { Box } from '@mui/material';
import { FC } from 'react';
import { FieldProps, TextField, useFieldHelper } from 'framework/ui/field';
import { formatChangeRequestAlias } from '../../billingUtils';

const MilestoneNameField: FC<FieldProps & { aliasSource: string; changeRequestAliasSource: string }> = props => {
  const { getValue } = useFieldHelper<string>({ source: props.source });
  const { getValue: getValueAlias } = useFieldHelper<string>({ source: props.aliasSource });
  const { getValue: getValueChangeRequestAlias } = useFieldHelper<string>({ source: props.changeRequestAliasSource });
  const name = getValue();
  const alias = getValueAlias();
  const changeRequestAlias = getValueChangeRequestAlias();
  if (changeRequestAlias) {
    return <TextField {...props} value={formatChangeRequestAlias(changeRequestAlias)} label="" />;
  }

  return (
    <Box display="flex">
      <TextField {...props} value={`${alias} ${name}`} label="" />
    </Box>
  );
};

export default MilestoneNameField;
